import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const SnackbarRest = ({ color = '#838685', ...rest }: Props) => {
  return (
    <Svg
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="error_FILL0_wght400_GRAD0_opsz24 (1) 1">
        <path
          id="Vector"
          d="M12.4999 17.7085C12.7951 17.7085 13.0425 17.6087 13.2421 17.409C13.4418 17.2094 13.5416 16.962 13.5416 16.6668C13.5416 16.3717 13.4418 16.1243 13.2421 15.9246C13.0425 15.725 12.7951 15.6252 12.4999 15.6252C12.2048 15.6252 11.9574 15.725 11.7577 15.9246C11.5581 16.1243 11.4583 16.3717 11.4583 16.6668C11.4583 16.962 11.5581 17.2094 11.7577 17.409C11.9574 17.6087 12.2048 17.7085 12.4999 17.7085ZM11.4583 13.5418H13.5416V7.29183H11.4583V13.5418ZM12.4999 22.9168C11.0589 22.9168 9.70478 22.6434 8.43742 22.0965C7.17006 21.5496 6.06763 20.8075 5.13013 19.87C4.19263 18.9325 3.45044 17.83 2.90356 16.5627C2.35669 15.2953 2.08325 13.9411 2.08325 12.5002C2.08325 11.0592 2.35669 9.70502 2.90356 8.43766C3.45044 7.1703 4.19263 6.06787 5.13013 5.13037C6.06763 4.19287 7.17006 3.45068 8.43742 2.90381C9.70478 2.35693 11.0589 2.0835 12.4999 2.0835C13.9409 2.0835 15.2951 2.35693 16.5624 2.90381C17.8298 3.45068 18.9322 4.19287 19.8697 5.13037C20.8072 6.06787 21.5494 7.1703 22.0963 8.43766C22.6431 9.70502 22.9166 11.0592 22.9166 12.5002C22.9166 13.9411 22.6431 15.2953 22.0963 16.5627C21.5494 17.83 20.8072 18.9325 19.8697 19.87C18.9322 20.8075 17.8298 21.5496 16.5624 22.0965C15.2951 22.6434 13.9409 22.9168 12.4999 22.9168ZM12.4999 20.8335C14.8263 20.8335 16.7968 20.0262 18.4114 18.4116C20.026 16.797 20.8333 14.8266 20.8333 12.5002C20.8333 10.1738 20.026 8.20329 18.4114 6.5887C16.7968 4.97412 14.8263 4.16683 12.4999 4.16683C10.1735 4.16683 8.20304 4.97412 6.58846 6.5887C4.97388 8.20329 4.16659 10.1738 4.16659 12.5002C4.16659 14.8266 4.97388 16.797 6.58846 18.4116C8.20304 20.0262 10.1735 20.8335 12.4999 20.8335Z"
          fill={color}
        />
      </g>
    </Svg>
  )
}

export default SnackbarRest
